import styled from 'styled-components';
import { colorTheme } from '@styles/muiTheme';

export const ContactTabHeader = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  max-width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;

  .MuiTypography-root {
    color: ${({ color, theme }) => color || theme.palette.primary.dark};
  }
`;

export const AssetsFilter = styled.div<{ color?: string; justify?: string }>`
  display: flex;
  justify-content: ${({ justify }) => justify || 'space-between'};
  width: 100%;
  .MuiTypography-root {
    color: ${({ color, theme }) => color || theme.palette.primary.dark};
  }
  .MuiButton-root {
    margin: unset;
  }
`;

export const SidebarWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: 0 -19px 0 0;
  color: ${colorTheme.palette.common.black};
  background: ${colorTheme.palette.secondary.light};
  border-left: 1px solid ${colorTheme.palette.secondary.light};
  max-height: calc(100vh - 306px);
  overflow-y: auto;
  overflow-x: hidden;
  position: sticky;
  top: 177px;
`;

export const Flex = styled.div`
  display: flex;
`;

export const Info = styled.span`
  font-size: 0.9rem;
  color: rgb(54 132 176);
  padding-left: 10px;
`;

export const Note = styled.span`
  font-size: 0.8rem;
  margin-bottom: 1rem;
  padding-left: 55px;
  padding-right: 2rem;
  width: 100%;
`;
